import {useEffect, useState} from 'react'
import {BooksitoutServer} from '../../../../config/BooksitoutServer'
import MonthlyBookCountResponse from '../responses/MonthlyBookCountResponse'

const useMonthlyBookCount = (year: number) => {
	const [data, setData] = useState<MonthlyBookCountResponse | null>(null)
	const [isLoading, setIsLoading] = useState<boolean>(true)

	useEffect(() => {
		setIsLoading(true)
		BooksitoutServer
			.get(`/v1/statistics/monthly-book-count`, {params: {year}})
			.then(res => setData(res.data))
			.finally(() => setIsLoading(false))
	}, [year])

	return [data, isLoading] as const
}

export default useMonthlyBookCount
